import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss'],
})
export class ApprovalsComponent extends OnDestroyMixin implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.data.pipe(untilComponentDestroyed(this)).subscribe(({ approval }) => {
      this.router.navigate([approval.related_to_type?.toLowerCase()], { relativeTo: this.activatedRoute });
    });
  }
}
